module.exports = __webpack_public_path__ + "img/receipt_progress2.c1ed2add.png";